import React from 'react';
import ReactDOM from 'react-dom';

const Modal2 = ({ children, visible, close }) => visible ?
    ReactDOM.createPortal(
        <div className='modal2'>
			<div className='modal__content2' onClick={() => { close(); }}>
				<div className='modal__content2' onClick={e => { e.stopPropagation(); }}>
                    {children}
                </div>
			</div>
        </div>
        , document.body
    )
: null;

export default Modal2;
